import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

type Props = {
    shown: boolean,
    onClose: () => void,
    onConfirm: () => void,
    busy: boolean,
};

export const DeleteUserDialog: React.FC<Props> = ({
    shown,
    onClose,
    onConfirm,
    busy,
}) => (
    <Dialog
        shown={shown}
        setShown={visible => {
            if (!visible && !busy) {
                onClose();
            }
        }}>
        <DialogHeader onClose={onClose}>
            <Typography variant="heading-level-2">
                Delete User
            </Typography>
        </DialogHeader>
        <Group direction="v" gap="m" style={{padding: 24, width: 500}}>
            <Typography variant="heading-level-6">
                Are you sure you want to delete this User?
            </Typography>
            <Typography> This will permanently remove the user&apos;s
                account and prevent them from logging into the system. This action cannot be undone.
            </Typography>
        </Group>
        <DialogFooter>
            <Button
                variant="Type.SECONDARY"
                disabled={busy}
                onClick={onClose}>
                Cancel
            </Button>
            <Button
                variant="Type.PRIMARY"
                busy={busy}
                onClick={onConfirm}>
                Delete
            </Button>
        </DialogFooter>
    </Dialog>
);
